export const Button = ({ children, onClick, className, ...props }) => {
  return (
    <button
      onClick={onClick}
      className={`${className} flex items-center justify-center rounded-full`}
      {...props}
    >
      {children}
    </button>
  );
};
